import React, { useEffect, useRef, useState } from "react";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { Button, Form, Overlay, Popover, Table } from "react-bootstrap";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import Loader from "../../../Loader/Loader";
import WidgetDetailModal from "../../WidgetDetailModal";
import { compName, month } from "../../../../utils/constant";
import { API_URL } from "../../../../utils/apiRoutes";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import WidgetNote from "../../WidgetNote";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import moment from "moment";
import SingleDateSummaryModal from "../../SingleDateSummaryModal";

const MonthlyCancellationPace = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const yearsArr = [
        ...commonService.getPastYearForDropDown(10),
        ...commonService.getFutureYearForDropDown(10),
        new Date().getFullYear(),
    ]?.sort(function (a, b) {
        return a - b;
    });
    const tableData = [
        {
            MonthName: "april",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "august",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "december",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "february",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "january",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "july",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "june",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "march",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "may",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "november",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "october",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
        {
            MonthName: "september",
            CP0: "0",
            CP1: "0",
            CP2TO7: "0",
            CP8TO15: "0",
            CP16TO30: "0",
            CP31TO60: "0",
            CP61TO90: "0",
            CP91TOUP: "0",
            CP0_REV: "0",
            CP1_REV: "0",
            CP2TO7_REV: "0",
            CP8TO15_REV: "0",
            CP16TO30_REV: "0",
            CP31TO60_REV: "0",
            CP61TO90_REV: "0",
            CP91TOUP_REV: "0",
            CP0_ADR: "0",
            CP1_ADR: "82",
            CP2TO7_ADR: "0",
            CP8TO15_ADR: "0",
            CP16TO30_ADR: "0",
            CP31TO60_ADR: "0",
            CP61TO90_ADR: "0",
            CP91TOUP_ADR: "0",
        },
    ];

    const getMonthTotalRms = (monthDataObj) => {
        if (!monthDataObj) return 0;
        if (monthDataObj.Total_RMS !== undefined && monthDataObj.Total_RMS !== null) {
            return parseInt(monthDataObj.Total_RMS) || 0;
        }
        return (
            (parseInt(monthDataObj.CP0) || 0) +
            (parseInt(monthDataObj.CP1) || 0) +
            (parseInt(monthDataObj.CP2TO7) || 0) +
            (parseInt(monthDataObj.CP8TO15) || 0) +
            (parseInt(monthDataObj.CP16TO30) || 0) +
            (parseInt(monthDataObj.CP31TO60) || 0) +
            (parseInt(monthDataObj.CP61TO90) || 0) +
            (parseInt(monthDataObj.CP91TOUP) || 0)
        );
    };

    const getMonthTotalRev = (monthDataObj) => {
        if (!monthDataObj) return 0;
        if (monthDataObj.Total_REV !== undefined && monthDataObj.Total_REV !== null) {
            return parseInt(monthDataObj.Total_REV) || 0;
        }
        return (
            (parseInt(monthDataObj.CP0_REV) || 0) +
            (parseInt(monthDataObj.CP1_REV) || 0) +
            (parseInt(monthDataObj.CP2TO7_REV) || 0) +
            (parseInt(monthDataObj.CP8TO15_REV) || 0) +
            (parseInt(monthDataObj.CP16TO30_REV) || 0) +
            (parseInt(monthDataObj.CP31TO60_REV) || 0) +
            (parseInt(monthDataObj.CP61TO90_REV) || 0) +
            (parseInt(monthDataObj.CP91TOUP_REV) || 0)
        );
    };

    const getMonthTotalAdr = (monthDataObj) => {
        if (!monthDataObj) return 0;
        if (monthDataObj.Total_ADR !== undefined && monthDataObj.Total_ADR !== null) {
            return parseInt(monthDataObj.Total_ADR) || 0;
        }
        const rms = getMonthTotalRms(monthDataObj);
        const rev = getMonthTotalRev(monthDataObj);
        return rms > 0 ? Math.round(rev / rms) : 0;
    };

    let total = {
        CP0: "0 Day",
        CP1: "1 Day",
        CP2TO7: "2 to 7 Days",
        CP8TO15: "8 to 15 Days",
        CP16TO30: "16 to 30 Days",
        CP31TO60: "31 to 60 Days",
        CP61TO90: "61 to 90 Days",
        CP91TOUP: "90+ Days",
    };

    let CP0 = 0,
        CP0_ADR = 0,
        CP0_ADR_COUNT = 0,
        CP0_REV = 0,
        CP1 = 0,
        CP1_ADR = 0,
        CP1_ADR_COUNT = 0,
        CP1_REV = 0,
        CP2TO7 = 0,
        CP2TO7_ADR = 0,
        CP2TO7_ADR_COUNT = 0,
        CP2TO7_REV = 0,
        CP8TO15 = 0,
        CP8TO15_ADR = 0,
        CP8TO15_ADR_COUNT = 0,
        CP8TO15_REV = 0,
        CP16TO30 = 0,
        CP16TO30_ADR = 0,
        CP16TO30_ADR_COUNT = 0,
        CP16TO30_REV = 0,
        CP31TO60 = 0,
        CP31TO60_ADR = 0,
        CP31TO60_ADR_COUNT = 0,
        CP31TO60_REV = 0,
        CP61TO90 = 0,
        CP61TO90_ADR = 0,
        CP61TO90_ADR_COUNT = 0,
        CP61TO90_REV = 0,
        CP91TOUP = 0,
        CP91TOUP_ADR = 0,
        CP91TOUP_ADR_COUNT = 0,
        CP91TOUP_REV = 0,
        totalRms = 0,
        totalAdr = 0,
        totalRev = 0;

    const [loading, setLoading] = useState(false);
    const [monthlyCancellationData, setMonthlyCancellationData] = useState(null);

    const [IsAllZero, setIsAllZero] = useState(false);

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [widgetModal, setWidgetModal] = useState(false);
    const widgetDetailRef = useRef();
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const singleDateSelectedDateRef = useRef(null);
    const selectedTdIndexRef = useRef(-1);

    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
      IsDisplay: false,
      Target: null,
      Position: "top",
    });

    const [RMSRequest, setRMSRequest] = useState(null);
    const [requestFor, setRequestFor] = useState("");

    const handleCancelledNightsClick = (event, monthItem, monthIndex, colIndex) => {
        // Construct date range for the clicked month
        const startOfSelectedMonth = moment([selectedYear, monthIndex]).startOf('month').format("YYYY-MM-DD");
        const endOfSelectedMonth = moment([selectedYear, monthIndex]).endOf('month').format("YYYY-MM-DD");
        setRequestFor("Monthly_Cancellation_Window")
        singleDateSelectedDateRef.current = {
            startdate: startOfSelectedMonth,
            enddate: endOfSelectedMonth,
        };

        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
        selectedTdIndexRef.current = monthIndex * 10 + colIndex;
    };
    
    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        setRequestFor("");
        setONTHEBOOKS({
        IsDisplay: false,
        Target: null,
        Position: "bottom",
        });
    };
    
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const getMonthlyCancellationData = async () => {
        setLoading(true);
        let monthlyCancellationResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.CANCELLATION.MONTHLY_CANCELLATION_PACE,
                body: {
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                },
            },
            false
        );

        let response = apiResponse(false, monthlyCancellationResponse);

        if (response?.isValidate) {


            const isAllZero = response?.data?.data.every(monthObj =>
                Object.entries(monthObj)
                    .filter(([key]) => key !== "MonthName")
                    .every(([, value]) => value === "0")
            );
            setIsAllZero(isAllZero);

            setMonthlyCancellationData(response?.data?.data);

            setLoading(false);

            if (isAllZero) {
                const widget = document.getElementById("widget_" + tblids.monthlyCancellationSummary);

                if (widget) {
                    const snapshotContainer = widget.closest('.snapshot_data_object');

                    if (snapshotContainer) {
                        snapshotContainer.remove();
                    }
                }

            }
        }

        if (!response?.isValidate) {
            setMonthlyCancellationData(tableData);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                getMonthlyCancellationData();
            }
        }
    }, [para?.asOfDate, selectedYear]);

    const [tblids, settblids] = useState({
        monthlyCancellationSummary: commonService.GenerateGUID(),
    });

    return (

        <div className="widget-container" style={{ position: "relative" }} id={"widget_" + tblids.monthlyCancellationSummary}>
            {
                !IsAllZero &&
                <> {api !== 0 && (
                    <div className="gap-1 widget-container-menu">
                        <Button className="heading-menu-btns" type="button" title="Send Mail">
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "emailicon", propertyCode)}
                                src={emailIcon}
                                alt="emailIcon"
                                onClick={() => {
                                    commonService.fnSendWidgetMail(
                                        tblids.monthlyCancellationSummary,
                                        "Monthly Cancellation Summary",
                                        snapshotId,
                                        defaultAsOfDateFromRTK,
                                        "",
                                        para?.widgetId
                                    );
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "info", propertyCode)}
                                src={infoIcon}
                                alt="info"
                                onClick={() => {
                                    widgetDetailRef.current = {
                                        widgetdetails: "",
                                        usernote: "",
                                        compName: compName?.monthlyCancellationPace,
                                        widgetId: para?.widgetId,
                                    };
                                    setWidgetModal(true);
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "menuicon", propertyCode)}
                                src={downloadIcon}
                                alt="menuIcon"
                                import={tblids.monthlyCancellationSummary}
                                onClick={() =>
                                    commonService.fnExportInCSV(
                                        tblids.monthlyCancellationSummary,
                                        // "Monthly Cancellation Summary"
                                        `${para?.propertyCode}-Monthly Cancellation Summary-${moment(
                                            new Date()
                                        ).format("MMDDYYYY")}`
                                    )
                                }
                            />
                        </Button>
                    </div>
                )}
                    <div className="ViewPropertySetupTable">
                        <div className="stripped__table">
                            <Table id={tblids.monthlyCancellationSummary} responsive>
                                <thead>
                                    <tr>
                                        <th className="text-center" colSpan={28}>
                                            MONTHLY CANCELLATION Window
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className="border_right width75">
                                            <div>
                                                <Form.Select id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-month", propertyCode)}
                                                    value={selectedYear}
                                                    onChange={(e) => {
                                                        setSelectedYear(e.target.value);
                                                    }}
                                                >
                                                    {yearsArr?.map((item, index) => (
                                                        <option key={index} value={item}>
                                                            {item}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <span style={{ display: "none" }}>{selectedYear}</span>
                                            </div>
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            Total
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            0 Day
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            1 Day
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            2 to 7 Days
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            8 to 15 Days
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            16 to 30 Days
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            31 to 60 Days
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            61 to 90 Days
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            90+ Days
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className="border_right">Month</th>
                                        
                                        <th className="text-center">Cancelled Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end border_right">Revenue Loss</th>
                                        
                                        <th className="text-center">Cancelled Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end border_right">Revenue Loss</th>
                                        <th className="text-center">Cancelled Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end border_right">Revenue Loss</th>
                                        <th className="text-center">Cancelled Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end border_right">Revenue Loss</th>
                                        <th className="text-center">Cancelled Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end border_right">Revenue Loss</th>
                                        <th className="text-center">Cancelled Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end border_right">Revenue Loss</th>
                                        <th className="text-center">Cancelled Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end border_right">Revenue Loss</th>
                                        <th className="text-center">Cancelled Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end border_right">Revenue Loss</th>
                                        <th className="text-center">Cancelled Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end border_right">Revenue Loss</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr style={{ height: "80px", position: "relative" }}>
                                            <Loader />
                                        </tr>
                                    ) : (
                                        month?.map((item, index) => {
                                            let findMonthData = monthlyCancellationData?.filter(
                                                (x) =>
                                                    x?.MonthName?.trim()?.toLowerCase() ===
                                                    item?.toLowerCase()
                                            );

                                            let monthStartDate = moment(
                                            `${selectedYear}-${item}`,
                                            "YYYY-MMMM"
                                            ).startOf("month").format("YYYY-MM-DD");

                                            let monthEndDate = moment(
                                            `${selectedYear}-${item}`,
                                            "YYYY-MMMM"
                                            ).endOf("month").format("YYYY-MM-DD");

                                            let monthStartDateLy = moment(
                                            `${selectedYear - 1}-${item}`,
                                            "YYYY-MMMM"
                                            ).startOf("month").format("YYYY-MM-DD");

                                            let monthEndDateLy = moment(
                                            `${selectedYear - 1}-${item}`,
                                            "YYYY-MMMM"
                                            ).endOf("month").format("YYYY-MM-DD");

                                            const rowRms = getMonthTotalRms(findMonthData?.[0]);
                                            const rowRev = getMonthTotalRev(findMonthData?.[0]);
                                            totalRms = totalRms + rowRms;
                                            totalRev = totalRev + rowRev;

                                            CP0 =
                                                CP0 +
                                                (findMonthData?.[0]?.CP0
                                                    ? parseInt(findMonthData?.[0]?.CP0)
                                                    : 0);

                                            CP0_ADR =
                                                CP0_ADR +
                                                (findMonthData?.[0]?.CP0_ADR
                                                    ? parseInt(findMonthData?.[0]?.CP0_ADR)
                                                    : 0);

                                            if (
                                                findMonthData?.[0]?.CP0_ADR !== "0" &&
                                                findMonthData?.[0]?.CP0_ADR
                                            ) {
                                                CP0_ADR_COUNT = CP0_ADR_COUNT + 1;
                                            }

                                            CP0_REV =
                                                CP0_REV +
                                                (findMonthData?.[0]?.CP0_REV
                                                    ? parseInt(findMonthData?.[0]?.CP0_REV)
                                                    : 0);

                                            CP1 =
                                                CP1 +
                                                (findMonthData?.[0]?.CP1
                                                    ? parseInt(findMonthData?.[0]?.CP1)
                                                    : 0);

                                            CP1_ADR =
                                                CP1_ADR +
                                                (findMonthData?.[0]?.CP1_ADR
                                                    ? parseInt(findMonthData?.[0]?.CP1_ADR)
                                                    : 0);

                                            if (
                                                findMonthData?.[0]?.CP1_ADR !== "0" &&
                                                findMonthData?.[0]?.CP1_ADR
                                            ) {
                                                CP1_ADR_COUNT = CP1_ADR_COUNT + 1;
                                            }

                                            CP1_REV =
                                                CP1_REV +
                                                (findMonthData?.[0]?.CP1_REV
                                                    ? parseInt(findMonthData?.[0]?.CP1_REV)
                                                    : 0);

                                            CP2TO7 =
                                                CP2TO7 +
                                                (findMonthData?.[0]?.CP2TO7
                                                    ? parseInt(findMonthData?.[0]?.CP2TO7)
                                                    : 0);

                                            CP2TO7_ADR =
                                                CP2TO7_ADR +
                                                (findMonthData?.[0]?.CP2TO7_ADR
                                                    ? parseInt(findMonthData?.[0]?.CP2TO7_ADR)
                                                    : 0);

                                            if (
                                                findMonthData?.[0]?.CP2TO7_ADR !== "0" &&
                                                findMonthData?.[0]?.CP2TO7_ADR
                                            ) {
                                                CP2TO7_ADR_COUNT = CP2TO7_ADR_COUNT + 1;
                                            }

                                            CP2TO7_REV =
                                                CP2TO7_REV +
                                                (findMonthData?.[0]?.CP2TO7_REV
                                                    ? parseInt(findMonthData?.[0]?.CP2TO7_REV)
                                                    : 0);

                                            CP8TO15 =
                                                CP8TO15 +
                                                (findMonthData?.[0]?.CP8TO15
                                                    ? parseInt(findMonthData?.[0]?.CP8TO15)
                                                    : 0);

                                            CP8TO15_ADR =
                                                CP8TO15_ADR +
                                                (findMonthData?.[0]?.CP8TO15_ADR
                                                    ? parseInt(findMonthData?.[0]?.CP8TO15_ADR)
                                                    : 0);

                                            if (
                                                findMonthData?.[0]?.CP8TO15_ADR !== "0" &&
                                                findMonthData?.[0]?.CP8TO15_ADR
                                            ) {
                                                CP8TO15_ADR_COUNT = CP8TO15_ADR_COUNT + 1;
                                            }

                                            CP8TO15_REV =
                                                CP8TO15_REV +
                                                (findMonthData?.[0]?.CP8TO15_REV
                                                    ? parseInt(findMonthData?.[0]?.CP8TO15_REV)
                                                    : 0);

                                            CP16TO30 =
                                                CP16TO30 +
                                                (findMonthData?.[0]?.CP16TO30
                                                    ? parseInt(findMonthData?.[0]?.CP16TO30)
                                                    : 0);

                                            CP16TO30_ADR =
                                                CP16TO30_ADR +
                                                (findMonthData?.[0]?.CP16TO30_ADR
                                                    ? parseInt(findMonthData?.[0]?.CP16TO30_ADR)
                                                    : 0);

                                            if (
                                                findMonthData?.[0]?.CP16TO30_ADR !== "0" &&
                                                findMonthData?.[0]?.CP16TO30_ADR
                                            ) {
                                                CP16TO30_ADR_COUNT = CP16TO30_ADR_COUNT + 1;
                                            }

                                            CP16TO30_REV =
                                                CP16TO30_REV +
                                                (findMonthData?.[0]?.CP16TO30_REV
                                                    ? parseInt(findMonthData?.[0]?.CP16TO30_REV)
                                                    : 0);

                                            CP31TO60 =
                                                CP31TO60 +
                                                (findMonthData?.[0]?.CP31TO60
                                                    ? parseInt(findMonthData?.[0]?.CP31TO60)
                                                    : 0);

                                            CP31TO60_ADR =
                                                CP31TO60_ADR +
                                                (findMonthData?.[0]?.CP31TO60_ADR
                                                    ? parseInt(findMonthData?.[0]?.CP31TO60_ADR)
                                                    : 0);

                                            if (
                                                findMonthData?.[0]?.CP31TO60_ADR !== "0" &&
                                                findMonthData?.[0]?.CP31TO60_ADR
                                            ) {
                                                CP31TO60_ADR_COUNT = CP31TO60_ADR_COUNT + 1;
                                            }

                                            CP31TO60_REV =
                                                CP31TO60_REV +
                                                (findMonthData?.[0]?.CP31TO60_REV
                                                    ? parseInt(findMonthData?.[0]?.CP31TO60_REV)
                                                    : 0);

                                            CP61TO90 =
                                                CP61TO90 +
                                                (findMonthData?.[0]?.CP61TO90
                                                    ? parseInt(findMonthData?.[0]?.CP61TO90)
                                                    : 0);

                                            CP61TO90_ADR =
                                                CP61TO90_ADR +
                                                (findMonthData?.[0]?.CP61TO90_ADR
                                                    ? parseInt(findMonthData?.[0]?.CP61TO90_ADR)
                                                    : 0);

                                            if (
                                                findMonthData?.[0]?.CP61TO90_ADR !== "0" &&
                                                findMonthData?.[0]?.CP61TO90_ADR
                                            ) {
                                                CP61TO90_ADR_COUNT = CP61TO90_ADR_COUNT + 1;
                                            }

                                            CP61TO90_REV =
                                                CP61TO90_REV +
                                                (findMonthData?.[0]?.CP61TO90_REV
                                                    ? parseInt(findMonthData?.[0]?.CP61TO90_REV)
                                                    : 0);

                                            CP91TOUP =
                                                CP91TOUP +
                                                (findMonthData?.[0]?.CP91TOUP
                                                    ? parseInt(findMonthData?.[0]?.CP91TOUP)
                                                    : 0);

                                            CP91TOUP_ADR =
                                                CP91TOUP_ADR +
                                                (findMonthData?.[0]?.CP91TOUP_ADR
                                                    ? parseInt(findMonthData?.[0]?.CP91TOUP_ADR)
                                                    : 0);

                                            if (
                                                findMonthData?.[0]?.CP91TOUP_ADR !== "0" &&
                                                findMonthData?.[0]?.CP91TOUP_ADR
                                            ) {
                                                CP91TOUP_ADR_COUNT = CP91TOUP_ADR_COUNT + 1;
                                            }

                                            CP91TOUP_REV =
                                                CP91TOUP_REV +
                                                (findMonthData?.[0]?.CP91TOUP_REV
                                                    ? parseInt(findMonthData?.[0]?.CP91TOUP_REV)
                                                    : 0);

                                            return (
                                                <React.Fragment key={index}>
                                                    <tr className="shadowOnHover">
                                                        <td className="border_right">{item}</td>

                                                         <td className="text-center text-primary">
                                                             <span id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-total-c", item)}
                                                                 className={`cursorPointer ${
                                                                     selectedTdIndexRef.current === (index * 10 + 0)
                                                                         ? "singleDateSummarySpan"
                                                                         : ""
                                                                 }`}
                                                                 onClick={(e) =>{
                                                                    
                                                                    setRMSRequest({
                                                                    "startdate": monthStartDate,
                                                                    "enddate": monthEndDate,
                                                                    "startdately": monthStartDateLy,
                                                                    "enddately": monthEndDateLy,
                                                                    "minleadtime": 0,
                                                                    "maxleadtime": 9999
                                                                    })
                                                                    handleCancelledNightsClick(e, item, index, 0)}
                                                                }
                                                             >
                                                                 {commonService.formateRoom(rowRms)}
                                                             </span>
                                                         </td>
                                                        <td className="text-end">
                                                            {commonService.formateAmount(getMonthTotalAdr(findMonthData?.[0]))}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {commonService.formateAmount(rowRev)}
                                                        </td>

                                                         <td className="text-center text-primary">
                                                             <span id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-0-day-c", item)}
                                                                 className={`cursorPointer ${
                                                                     selectedTdIndexRef.current === (index * 10 + 1)
                                                                         ? "singleDateSummarySpan"
                                                                         : ""
                                                                 }`}
                                                                 onClick={(e) => {
                                                                     
                                                                    setRMSRequest({
                                                                    "startdate": monthStartDate,
                                                                    "enddate": monthEndDate,
                                                                    "startdately": monthStartDateLy,
                                                                    "enddately": monthEndDateLy,
                                                                    "minleadtime": 0,
                                                                    "maxleadtime": 0
                                                                    })
                                                                    handleCancelledNightsClick(e, item, index, 1)}}
                                                             >
                                                                 {findMonthData?.[0]?.CP0
                                                                     ? commonService.formateRoom(findMonthData?.[0]?.CP0)
                                                                     : 0}
                                                             </span>
                                                         </td>
                                                        <td className="text-end">
                                                            {findMonthData?.[0]?.CP0_ADR
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP0_ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {findMonthData?.[0]?.CP0_REV
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP0_REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>

                                                         <td className="text-center text-primary">
                                                             <span id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-1-day-c", item)}
                                                                 className={`cursorPointer ${
                                                                     selectedTdIndexRef.current === (index * 10 + 2)
                                                                         ? "singleDateSummarySpan"
                                                                         : ""
                                                                 }`}
                                                                 onClick={(e) => {
                                                                        
                                                                    setRMSRequest({
                                                                    "startdate": monthStartDate,
                                                                    "enddate": monthEndDate,
                                                                    "startdately": monthStartDateLy,
                                                                    "enddately": monthEndDateLy,
                                                                    "minleadtime": 1,
                                                                    "maxleadtime": 1
                                                                    })
                                                                    handleCancelledNightsClick(e, item, index, 2)}}
                                                             >
                                                                 {findMonthData?.[0]?.CP1
                                                                     ? commonService.formateRoom(findMonthData?.[0]?.CP1)
                                                                     : 0}
                                                             </span>
                                                         </td>
                                                        <td className="text-end">
                                                            {findMonthData?.[0]?.CP1_ADR
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP1_ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {findMonthData?.[0]?.CP1_REV
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP1_REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>

                                                         <td className="text-center text-primary">
                                                             <span id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-2-to-7", item)}
                                                                 className={`cursorPointer ${
                                                                     selectedTdIndexRef.current === (index * 10 + 3)
                                                                         ? "singleDateSummarySpan"
                                                                         : ""
                                                                 }`}
                                                                 onClick={(e) => {
                                                                       
                                                                    setRMSRequest({
                                                                    "startdate": monthStartDate,
                                                                    "enddate": monthEndDate,
                                                                    "startdately": monthStartDateLy,
                                                                    "enddately": monthEndDateLy,
                                                                    "minleadtime": 2,
                                                                    "maxleadtime": 7
                                                                    })
                                                                    handleCancelledNightsClick(e, item, index, 3)}}
                                                             >
                                                                 {findMonthData?.[0]?.CP2TO7
                                                                     ? commonService.formateRoom(findMonthData?.[0]?.CP2TO7)
                                                                     : 0}
                                                             </span>
                                                         </td>
                                                        <td className="text-end">
                                                            {findMonthData?.[0]?.CP2TO7_ADR
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP2TO7_ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {findMonthData?.[0]?.CP2TO7_REV
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP2TO7_REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>

                                                         <td className="text-center text-primary">
                                                             <span id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-8-to-15", item)}
                                                                 className={`cursorPointer ${
                                                                     selectedTdIndexRef.current === (index * 10 + 4)
                                                                         ? "singleDateSummarySpan"
                                                                         : ""
                                                                 }`}
                                                                 onClick={(e) => {
                                                                    
                                                                    setRMSRequest({
                                                                    "startdate": monthStartDate,
                                                                    "enddate": monthEndDate,
                                                                    "startdately": monthStartDateLy,
                                                                    "enddately": monthEndDateLy,
                                                                    "minleadtime": 8,
                                                                    "maxleadtime": 15
                                                                    })
                                                                    handleCancelledNightsClick(e, item, index, 4)}}
                                                             >
                                                                 {findMonthData?.[0]?.CP8TO15
                                                                     ? commonService.formateRoom(findMonthData?.[0]?.CP8TO15)
                                                                     : 0}
                                                             </span>
                                                         </td>
                                                        <td className="text-end">
                                                            {findMonthData?.[0]?.CP8TO15_ADR
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP8TO15_ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {findMonthData?.[0]?.CP8TO15_REV
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP8TO15_REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>

                                                         <td className="text-center text-primary">
                                                             <span id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-16-to-3", item)}
                                                                 className={`cursorPointer ${
                                                                     selectedTdIndexRef.current === (index * 10 + 5)
                                                                         ? "singleDateSummarySpan"
                                                                         : ""
                                                                 }`}
                                                                 onClick={(e) => {
                                                                    
                                                                    setRMSRequest({
                                                                    "startdate": monthStartDate,
                                                                    "enddate": monthEndDate,
                                                                    "startdately": monthStartDateLy,
                                                                    "enddately": monthEndDateLy,
                                                                    "minleadtime": 16,
                                                                    "maxleadtime": 30
                                                                    })
                                                                    handleCancelledNightsClick(e, item, index, 5)}}
                                                             >
                                                                 {findMonthData?.[0]?.CP16TO30
                                                                     ? commonService.formateRoom(findMonthData?.[0]?.CP16TO30)
                                                                     : 0}
                                                             </span>
                                                         </td>
                                                        <td className="text-end">
                                                            {findMonthData?.[0]?.CP16TO30_ADR
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP16TO30_ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {findMonthData?.[0]?.CP16TO30_REV
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP16TO30_REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>

                                                         <td className="text-center text-primary">
                                                             <span id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-31-to-6", item)}
                                                                 className={`cursorPointer ${
                                                                     selectedTdIndexRef.current === (index * 10 + 6)
                                                                         ? "singleDateSummarySpan"
                                                                         : ""
                                                                 }`}
                                                                 onClick={(e) => {
                                                                     
                                                                    setRMSRequest({
                                                                    "startdate": monthStartDate,
                                                                    "enddate": monthEndDate,
                                                                    "startdately": monthStartDateLy,
                                                                    "enddately": monthEndDateLy,
                                                                    "minleadtime": 31,
                                                                    "maxleadtime": 60
                                                                    })
                                                                    handleCancelledNightsClick(e, item, index, 6)}}
                                                             >
                                                                 {findMonthData?.[0]?.CP31TO60
                                                                     ? commonService.formateRoom(findMonthData?.[0]?.CP31TO60)
                                                                     : 0}
                                                             </span>
                                                         </td>
                                                        <td className="text-end">
                                                            {findMonthData?.[0]?.CP31TO60_ADR
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP31TO60_ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {findMonthData?.[0]?.CP31TO60_REV
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP31TO60_REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>

                                                         <td className="text-center text-primary">
                                                             <span id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-61-to-9", item)}
                                                                 className={`cursorPointer ${
                                                                     selectedTdIndexRef.current === (index * 10 + 7)
                                                                         ? "singleDateSummarySpan"
                                                                         : ""
                                                                 }`}
                                                                 onClick={(e) => {
                                                                        
                                                                    setRMSRequest({
                                                                    "startdate": monthStartDate,
                                                                    "enddate": monthEndDate,
                                                                    "startdately": monthStartDateLy,
                                                                    "enddately": monthEndDateLy,
                                                                    "minleadtime": 61,
                                                                    "maxleadtime": 90
                                                                    })
                                                                    handleCancelledNightsClick(e, item, index, 7)}}
                                                             >
                                                                 {findMonthData?.[0]?.CP61TO90
                                                                     ? commonService.formateRoom(findMonthData?.[0]?.CP61TO90)
                                                                     : 0}
                                                             </span>
                                                         </td>
                                                        <td className="text-end">
                                                            {findMonthData?.[0]?.CP61TO90_ADR
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP61TO90_ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {findMonthData?.[0]?.CP61TO90_REV
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP61TO90_REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>

                                                         <td className="text-center text-primary">
                                                             <span id={commonService.generateGlobalClickTrackerID("MonthlyCancellationPace", "monthly-cancellation-window-90-days", item)}
                                                                 className={`cursorPointer ${
                                                                     selectedTdIndexRef.current === (index * 10 + 8)
                                                                         ? "singleDateSummarySpan"
                                                                         : ""
                                                                 }`}
                                                                 onClick={(e) => {
                                                                     
                                                                    setRMSRequest({
                                                                    "startdate": monthStartDate,
                                                                    "enddate": monthEndDate,
                                                                    "startdately": monthStartDateLy,
                                                                    "enddately": monthEndDateLy,
                                                                    "minleadtime": 91,
                                                                    "maxleadtime": 9999
                                                                    })
                                                                    handleCancelledNightsClick(e, item, index, 8)}}
                                                             >
                                                                 {findMonthData?.[0]?.CP91TOUP
                                                                     ? commonService.formateRoom(findMonthData?.[0]?.CP91TOUP)
                                                                     : 0}
                                                             </span>
                                                         </td>
                                                        <td className="text-end">
                                                            {findMonthData?.[0]?.CP91TOUP_ADR
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP91TOUP_ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {findMonthData?.[0]?.CP91TOUP_REV
                                                                ? commonService.formateAmount(
                                                                    findMonthData?.[0]?.CP91TOUP_REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                    </tr>
                                                    {index === 11 && (
                                                        <tr className="shadowOnHover">
                                                            <td className="boldTd border_right">Total</td>

                                                            <td className="boldTd text-center">
                                                                {commonService.formateRoom(totalRms)}
                                                            </td>
                                                            <td className="boldTd text-end">
                                                                {totalRms > 0 && totalRev > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(totalRev / totalRms)
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="boldTd text-end border_right">
                                                                {commonService.formateAmount(totalRev)}
                                                            </td>

                                                            <td className="boldTd text-center">{commonService.formateRoom(CP0)}</td>
                                                            <td className="boldTd text-end">
                                                                {CP0 > 0 && CP0_REV > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(CP0_REV / CP0)
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="boldTd text-end border_right">
                                                                {commonService.formateAmount(CP0_REV)}
                                                            </td>

                                                            <td className="boldTd text-center">{commonService.formateRoom(CP1)}</td>
                                                            <td className="boldTd text-end">
                                                                {CP1 > 0 && CP1_REV > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(CP1_REV / CP1)
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="boldTd text-end border_right">
                                                                {commonService.formateAmount(CP1_REV)}
                                                            </td>

                                                            <td className="boldTd text-center">{commonService.formateRoom(CP2TO7)}</td>
                                                            <td className="boldTd text-end">
                                                                {CP2TO7 > 0 && CP2TO7_REV > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(CP2TO7_REV / CP2TO7)
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="boldTd text-end border_right">
                                                                {commonService.formateAmount(CP2TO7_REV)}
                                                            </td>

                                                            <td className="boldTd text-center">{commonService.formateRoom(CP8TO15)}</td>
                                                            <td className="boldTd text-end">
                                                                {CP8TO15 > 0 && CP8TO15_REV > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(CP8TO15_REV / CP8TO15)
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="boldTd text-end border_right">
                                                                {commonService.formateAmount(CP8TO15_REV)}
                                                            </td>

                                                            <td className="boldTd text-center">{commonService.formateRoom(CP16TO30)}</td>
                                                            <td className="boldTd text-end">
                                                                {CP16TO30 > 0 && CP16TO30_REV > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(CP16TO30_REV / CP16TO30)
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="boldTd text-end border_right">
                                                                {commonService.formateAmount(CP16TO30_REV)}
                                                            </td>

                                                            <td className="boldTd text-center">{commonService.formateRoom(CP31TO60)}</td>
                                                            <td className="boldTd text-end">
                                                                {CP31TO60 > 0 && CP31TO60_REV > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(CP31TO60_REV / CP31TO60)
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="boldTd text-end border_right">
                                                                {commonService.formateAmount(CP31TO60_REV)}
                                                            </td>

                                                            <td className="boldTd text-center">{commonService.formateRoom(CP61TO90)}</td>
                                                            <td className="boldTd text-end">
                                                                {CP61TO90 > 0 && CP61TO90_REV > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(CP61TO90_REV / CP61TO90)
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="boldTd text-end border_right">
                                                                {commonService.formateAmount(CP61TO90_REV)}
                                                            </td>

                                                            <td className="boldTd text-center">{commonService.formateRoom(CP91TOUP)}</td>
                                                            <td className="boldTd text-end">
                                                                {CP91TOUP > 0 && CP91TOUP_REV > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(CP91TOUP_REV / CP91TOUP)
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="boldTd text-end border_right">
                                                                {commonService.formateAmount(CP91TOUP_REV)}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    {api !== 0 && (
                        <Comments widgetDetails={para} editorId={"MonthlyCancellationPace"} />
                    )}
                    {showNoteSidebar && (
                        <AddWidgetModal
                            showModal={showNoteSidebar}
                            closeModal={closeNoteSideBar}
                            widgetId={para?.widgetId}
                            propertyId={propertyDetailFromRTK?.propertyid}
                            rowTitle={para?.rowTitle}
                        />
                    )}
                    {widgetModal && (
                        <WidgetDetailModal
                            showModal={widgetModal}
                            closeModal={closeWidgetModal}
                            data={widgetDetailRef.current}
                        />
                    )}
                </>
            }

    <Overlay
        show={ONTHEBOOKS.IsDisplay}
        target={ONTHEBOOKS.Target}
        placement={ONTHEBOOKS.Position}
        rootClose={true}
        onHide={closeSingleDate}
      >
        <Popover
          id="popover-contained"
          className="SingleDateSummaryModalPopoverMain groupwash-modal-overlay"
        >
          <div className="horizontal-menu-option active">
            <SingleDateSummaryModal
              requestFor={requestFor}
              RMSRequest={RMSRequest}
              closeModal={closeSingleDate}
              asOfDate={para?.asOfDate}
              selectedDate={singleDateSelectedDateRef.current}
              pickupDate={null}
              propertyDetail={{ propertyCode: para?.propertyCode }}
            />
          </div>
        </Popover>
    </Overlay>
        </div>
    );
};

export default MonthlyCancellationPace;
